import { render, staticRenderFns } from "./DocumentIssueDate.vue?vue&type=template&id=741498c4&scoped=true&"
import script from "./DocumentIssueDate.vue?vue&type=script&lang=js&"
export * from "./DocumentIssueDate.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "741498c4",
  null
  
)

export default component.exports